import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LoginPage from "@/pages/LoginPage";
import AuthCallback from "@/pages/AuthCallback";
import FeedPage from "@/pages/FeedPage";
import ItemPage from "@/pages/ItemPage";
import EditPage from "@/pages/EditPage";
import LockerPage from "@/pages/LockerPage";
import UploadPage from "@/pages/UploadPage";
import DealBuilderPage from "@/pages/DealBuilderPage";
import DealsPage from "@/pages/DealsPage";
import ChatPage from "@/pages/ChatPage";
import ProfilePage from "@/pages/ProfilePage";
import PublicProfilePage from "@/pages/PublicProfilePage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import AdminPage from "@/pages/AdminPage";
import LandingPage from "@/pages/LandingPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import BottomNav from "@/components/BottomNav";
import DesktopHeader from "@/components/DesktopHeader";
import DesktopSidebar from "@/components/DesktopSidebar";
import DesktopRightPanel from "@/components/DesktopRightPanel";

function AppContent() {
  const location = useLocation();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  const hideNav = location.pathname === '/login' || location.pathname.startsWith('/chat/') || location.pathname === '/welcome';
  const isFullWidthPage = location.pathname === '/welcome' || location.pathname === '/terminos' || location.pathname === '/privacidad' || location.pathname === '/admin';

  const routeContent = (
    <Routes>
      <Route path="/" element={<FeedPage />} />
      <Route path="/feed" element={<Navigate to="/" replace />} />
      <Route path="/item/:itemId" element={<ItemPage />} />
      <Route path="/user/:userId" element={<PublicProfilePage />} />
      <Route path="/terminos" element={<TermsPage />} />
      <Route path="/privacidad" element={<PrivacyPage />} />
      <Route path="/welcome" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/locker" element={<ProtectedRoute><LockerPage /></ProtectedRoute>} />
      <Route path="/upload" element={<ProtectedRoute><UploadPage /></ProtectedRoute>} />
      <Route path="/edit/:itemId" element={<ProtectedRoute><EditPage /></ProtectedRoute>} />
      <Route path="/deal/:itemId" element={<ProtectedRoute><DealBuilderPage /></ProtectedRoute>} />
      <Route path="/deals" element={<ProtectedRoute><DealsPage /></ProtectedRoute>} />
      <Route path="/chat/:offerId" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
    </Routes>
  );

  if (isFullWidthPage) {
    return (
      <>
        {routeContent}
        {!hideNav && <BottomNav />}
        <Toaster position="top-center" theme="dark" toastOptions={{
          style: { background: '#111', border: '1px solid #1a1a1a', color: '#d5d5d5', fontFamily: 'Sora, Outfit, sans-serif' },
        }} />
      </>
    );
  }

  return (
    <>
      <DesktopHeader />
      <div className="desktop-layout">
        <DesktopSidebar />
        <main className="desktop-main">
          {routeContent}
        </main>
        <DesktopRightPanel />
      </div>
      {!hideNav && <BottomNav />}
      <Toaster position="top-center" theme="dark" toastOptions={{
        style: { background: '#111', border: '1px solid #1a1a1a', color: '#d5d5d5', fontFamily: 'Sora, Outfit, sans-serif' },
      }} />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
